// Collapsed remarks panel + vertical tab. Legacy parity (index.html
// L1736-1758): the right-side `.remarks-panel.collapsed` slides off-screen
// leaving its vertical handle `.remarks-tab` peeking on the edge with three
// status-color badges (open / blocked / pending count).
//
// In alpha.12 the popup + Kanban view handle remarks workflow, so this
// panel is a cosmetic stub: clicking the tab toggles `.collapsed` but the
// expanded panel body is empty (a hint pointing to the popup / Kanban).

import { For, Show, createMemo, createSignal } from 'solid-js';
import { stores } from '../state/store';

function badgeCount(status: 'open' | 'blocked' | 'pending'): number {
  return stores.state.remarks.filter((r) => {
    if (status === 'open') return r.status === 'open' || r.status === 'todo';
    if (status === 'blocked') return r.status === 'blocked' || r.status === 'wontfix';
    return r.status === 'pending' || r.status === 'doing';
  }).length;
}

export function RemarksTab() {
  const [collapsed, setCollapsed] = createSignal(true);
  const counts = createMemo(() => ({
    open: badgeCount('open'),
    blocked: badgeCount('blocked'),
    pending: badgeCount('pending'),
  }));

  return (
    <div class={`remarks-panel ${collapsed() ? 'collapsed' : ''}`} id="remarksPanel">
      <div
        class="remarks-tab"
        title="Toggle remarks panel (P)"
        onClick={() => setCollapsed((v) => !v)}
      >
        <span>Remarks</span>
        <div class="tab-badges">
          <span class={`tab-badge status-open ${counts().open === 0 ? 'zero' : ''}`}>
            {counts().open}
          </span>
          <span class={`tab-badge status-blocked ${counts().blocked === 0 ? 'zero' : ''}`}>
            {counts().blocked}
          </span>
          <span class={`tab-badge status-pending ${counts().pending === 0 ? 'zero' : ''}`}>
            {counts().pending}
          </span>
        </div>
      </div>
      <div class="remarks-header">
        <h3>Remarks</h3>
        <span class="count">{stores.state.remarks.length}</span>
      </div>
      <div class="remarks-list">
        <Show
          when={stores.state.remarks.length > 0}
          fallback={<p class="empty">No remarks yet</p>}
        >
          <For each={stores.state.remarks}>
            {(remark) => (
              <div class={`remark-item ${remark.status}`}>
                <div class="remark-meta">
                  <span class={`remark-number`}>{stores.state.remarks.indexOf(remark) + 1}</span>
                  <span class="remark-author">{remark.author.split('@')[0] ?? remark.author}</span>
                </div>
                <div class="remark-text">{remark.text}</div>
              </div>
            )}
          </For>
        </Show>
      </div>
    </div>
  );
}
